export default "__VITE_ASSET__BL$k_ox___"